import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/landing/brand-landing.png'
import _imports_1 from '../assets/gi-logo-image.png'
import _imports_2 from '../assets/landing/influencer-landing.png'
import _imports_3 from '../pages/creators/account/assets/agency-modal.svg'


const _withScopeId = n => (_pushScopeId("data-v-55358e05"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "side brand-side first" }, [
  /*#__PURE__*/_createElementVNode("h1", {
    class: "title",
    style: {"color":"white"}
  }, [
    /*#__PURE__*/_createTextVNode("I'm a "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" publisher / developer")
  ]),
  /*#__PURE__*/_createElementVNode("img", {
    class: "side-image",
    src: _imports_0
  })
], -1))
const _hoisted_3 = { class: "side brand-side second" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", {
    class: "secondary-title",
    style: {"color":"white"}
  }, "I'm a publisher / developer"),
  /*#__PURE__*/_createElementVNode("div", { class: "paragraph" }, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createTextVNode("G.IO is a platform that allows you as a brand to run"),
      /*#__PURE__*/_createElementVNode("strong", null, " your own influencer marketing campaigns.")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "p-mt-4" }, "Connect with thousands of ambitious micro and macro gaming influencers and promote your games through their communities! "),
    /*#__PURE__*/_createElementVNode("div", { class: "p-mt-4" }, [
      /*#__PURE__*/_createElementVNode("strong", null, " Promote your games through influencer marketing campaigns!")
    ])
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "side influencer-side first" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo-image-landing",
    src: _imports_1
  }),
  /*#__PURE__*/_createElementVNode("h1", {
    class: "title",
    style: {"color":"#e73d38"}
  }, [
    /*#__PURE__*/_createTextVNode("I'm an "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Influencer / Agency")
  ]),
  /*#__PURE__*/_createElementVNode("img", {
    class: "side-image",
    src: _imports_2
  })
], -1))
const _hoisted_6 = { class: "side influencer-side second" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<img class=\"logo-image-landing\" src=\"" + _imports_1 + "\" data-v-55358e05><h1 class=\"secondary-title\" style=\"color:#e73d38;\" data-v-55358e05>I&#39;m an Influencer / Agency</h1><div class=\"paragraph\" data-v-55358e05><div data-v-55358e05>G.IO is a platform that allows you as a content creator<strong data-v-55358e05> to browse active influencer marketing campaigns, take part, and get paid.</strong></div><div class=\"p-mt-4\" data-v-55358e05>You will connect with ambitious game developers and promote their games through your community. </div><div class=\"p-mt-4\" data-v-55358e05><strong data-v-55358e05>If you want to create content for brands and promote their games through your audience, you are in the right place!</strong></div></div>", 3)
const _hoisted_10 = {
  id: "section-lending",
  class: "mobile"
}
const _hoisted_11 = { class: "mobile-inf" }
const _hoisted_12 = { class: "mobile-inf-box" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "title",
  style: {"color":"#e73d38"}
}, [
  /*#__PURE__*/_createTextVNode("I'm an "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Influencer / Agency")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "and I want to create content for brands to promote games through my audience", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "side-image",
  src: _imports_2
}, null, -1))
const _hoisted_16 = { class: "mobile-brand" }
const _hoisted_17 = { class: "mobile-brand-box" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "title",
  style: {"color":"white"}
}, [
  /*#__PURE__*/_createTextVNode("I'm a "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" publisher / developer")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "and I want to promote my games through influencer marketing campaigns", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "side-image",
  src: _imports_0
}, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "succenss-modal-create" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "CONGRATS!"),
  /*#__PURE__*/_createElementVNode("p", null, "Now you can get the benefits from your Agency Account."),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: "agency-mosignup-btndal"
  })
], -1))
const _hoisted_22 = { class: "p-d-flex p-justify-center p-mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "brand",
        ref: "brandRef",
        onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.removeStyle('brandRef'))),
        onMouseover: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeStyle('brandRef')))
      }, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'brand-view' }))),
            class: "signup-btn"
          }, "Get Started")
        ])
      ], 544),
      _createElementVNode("div", {
        class: "influencer",
        ref: "influencerRef",
        onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (_ctx.removeStyle('influencerRef'))),
        onMouseover: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeStyle('influencerRef')))
      }, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push({ name: 'influencer-view' }))),
            class: "signup-btn"
          }, "Get Started ")
        ])
      ], 544),
      _createElementVNode("section", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _hoisted_14,
            _createElementVNode("button", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push({ name: 'influencer-view' }))),
              class: "signup-btn"
            }, "Get Started")
          ]),
          _hoisted_15
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _hoisted_19,
            _createElementVNode("button", {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$router.push({ name: 'brand-view' }))),
              class: "signup-btn"
            }, "Get Started")
          ]),
          _hoisted_20
        ])
      ])
    ]),
    _createVNode(_component_Dialog, {
      header: "",
      visible: _ctx.displaySuccessCreateAgency,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.displaySuccessCreateAgency) = $event)),
      style: { width: '50vw' }
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_Button, {
            class: "success-btn",
            label: "START EXPLOrING",
            onClick: _cache[8] || (_cache[8] = ($event: any) => {_ctx.displaySuccessCreateAgency = false; _ctx.$router.push({ name: 'dashboard' })})
          })
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_21
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}